import { AuditType } from "./audit.type";
import { Currency } from "./currency.type";

export enum AuditActionType {
  PROFIT = "Прибыль",
  EXPENSE = "Расход",
}

export interface IAuditAction extends Document {
  _id: string;
  auditId: string;
  type: AuditActionType;
  auditType: AuditType;
  ownerId: string;
  ownerName: string;
  amount: number;
  currency: Currency;
  date: string;
  netProfitAfter?: number;
  netProfitBefore?: number;
}
